import React, { useState } from 'react';

const ShareButton = () => {
  const [showToast, setShowToast] = useState(false);

  const handleShare = async () => {
    const shareData = {
      title: 'Check out InnerTap',
      text: 'Hey, You should check out this app called InnerTap. It\'s like a mix of meditation and affirmations you tap through at your own pace. Thought you might love it 💫',
      url: 'https://innertap.com'
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText('https://innertap.com');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 2000);
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  };

  return (
    <>
      <button 
        onClick={handleShare}
        className="share-button"
        aria-label="Share this page"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="18" cy="5" r="3"/>
          <circle cx="6" cy="12" r="3"/>
          <circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
      </button>
      {showToast && (
        <div className="toast-notification">
          Link copied to clipboard!
        </div>
      )}
    </>
  );
};

export default ShareButton; 